export default {
  bubbleLottie: require("../assets/lotties/bubbleLottie.json"),
  chatingLottie: require("../assets/lotties/chatingLottie.json"),
  completedLottie: require("../assets/lotties/completedLottie.json"),
  finishLottie: require("../assets/lotties/finishLottie.json"),
  brainstormingLottie: require("../assets/lotties/brainstormingLottie.json"),
  copywritingLottie: require("../assets/lotties/copywritingLottie.json"),
  graduateLottie: require("../assets/lotties/graduateLottie.json"),
};
